import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const checkoutPath = orderId
    ? `/checkout?orderId=${encodeURIComponent(orderId)}`
    : '/checkout';

  return <Navigate to={checkoutPath} replace />;
};

export default CheckoutSuccessPage;
